export function shouldShowAuthoringRecommendations({ isAuthoringScheduleEditor, isPreview, recommendationsEnabled }) {
    return Boolean(isAuthoringScheduleEditor) && !isPreview && Boolean(recommendationsEnabled)
}

export function shouldShowAuthoringDraftHistory({ isAuthoringScheduleEditor, isPreview, recommendationsEnabled }) {
    return Boolean(isAuthoringScheduleEditor) && !isPreview && Boolean(recommendationsEnabled)
}
